import { __decorate, __metadata } from "tslib";
import { Injectable } from '../../Core/DI/Decorators';
/**
 * 调试配置服务
 *
 * 管理调试系统的配置信息
 */
let DebugConfigService = class DebugConfigService {
    constructor() {
        this._config = {
            enabled: false,
            websocketUrl: '',
            debugFrameRate: 30,
            autoReconnect: true,
            channels: {
                entities: true,
                systems: true,
                performance: true,
                components: true,
                scenes: true
            }
        };
    }
    setConfig(config) {
        this._config = config;
    }
    getConfig() {
        return this._config;
    }
    isEnabled() {
        return this._config.enabled;
    }
    dispose() {
        // 清理资源
    }
};
DebugConfigService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], DebugConfigService);
export { DebugConfigService };
//# sourceMappingURL=DebugConfigService.js.map